import defaultPhoneMetadata from "libphonenumber-js/min/metadata";

// The phone input's formatting rules, except Indian numbers are shown as 10 digits
// ("98765 43210") instead of with the trunk 0 ("098765 43210").
export const phoneInputMetadataWithoutTrunkZero = (() => {
  const metadata = JSON.parse(JSON.stringify(defaultPhoneMetadata));
  const india = metadata?.countries?.IN;
  if (Array.isArray(india?.[4])) {
    india[4].forEach((format) => {
      if (typeof format?.[3] === "string") {
        format[3] = format[3].replace(/^0/, "");
      }
    });
  }
  return metadata;
})();

// The phone input only shows numbers written as "+<code><number>". Company phones
// can be stored without the "+" ("14148568965", "919876543210"), which shows the 1 / 91.
export const toPhoneInputValue = (raw) => {
  if (raw == null) {
    return "";
  }

  const value = String(raw).trim();
  if (value === "" || value.startsWith("+")) {
    return value;
  }

  const digits = value.replace(/\D+/g, "");
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (
    (digits.length === 11 && digits.startsWith("1")) ||
    (digits.length === 12 && digits.startsWith("91"))
  ) {
    return `+${digits}`;
  }

  return value;
};

export const normalizeUsCellPhone = (raw) => {
  if (raw == null) {
    return "";
  }

  const digits = String(raw).replace(/\D+/g, "");
  const national =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;

  if (national.length !== 10) {
    return "";
  }

  return `+1${national}`;
};

export const resolveUsCellPhone = (...candidates) => {
  for (const value of candidates) {
    const normalized = normalizeUsCellPhone(value);
    if (normalized) {
      return normalized;
    }
  }

  return "";
};

export const resolveProfileUsCellPhone = (profile) => {
  if (!profile || typeof profile !== "object") {
    return "";
  }

  return resolveUsCellPhone(
    profile.phone,
    profile.phone1,
    profile.phone_number,
  );
};
